module.exports = __webpack_public_path__ + "static/hero4-9e1f33c6fe99f22c34eebcc8d9483396.webp";